import {useNavigate} from "react-router-dom";
import {url} from "../../utils/urls";
import {isNotEmpty} from "../../utils/strings";
import {stopEvent} from "../../utils/events";
import {isEmptyList, isNullOrEmpty} from "../../utils/objects";
import {useEffect, useState} from "react";

const SideMenuItem = (
  {
    menuElement = {},
    fontColor = ""
  }) => {
  const [loading, setLoading] = useState(true);
  const [menu, setMenu] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      return;
    }
    setMenu(menuElement);

    setLoading(false);
  }, [loading]);

  const updateExpanded = (expanded = true) => {
    setMenu((prevState) => ({...prevState, expanded: expanded}));
  }


  const handleClick = (e, path) => {
    stopEvent(e);
    navigate(path, {state: {ok: true}});
  }

  return (
    (!isNullOrEmpty(menu) ?
      (
        <>
          <li style={menu.style}
              className={menu.attr.className}
          >
            <div className={"menu-item"}>
              <a href={url(menu.attr.href)}
                 style={isNotEmpty(fontColor) ? {color: fontColor}:{}}
                 onClick={(e) => {handleClick(e, url(menu.attr.href))}} >{menu.innerText}</a>
              {!isEmptyList(menu.children) &&
                <>
                  {!menu["expanded"] ?
                  <span className={"arrow arrow-right sp"}
                        onClick={() => updateExpanded(true)}
                  >
                    <i className="fas fa-caret-right"></i>
                  </span>
                    :
                  <span className={"arrow arrow-right sp"}
                        onClick={() => updateExpanded(false)}
                  ><i className="fas fa-caret-left"></i></span>
                  }
                </>
              }
            </div>
            {(!isEmptyList(menu.children) && menu["expanded"]) &&
              <ul>
                {menu.children.map((submenu) =>
                  <>
                  <SideMenuItem
                    key={"k-" + submenu.id}
                    data-id={submenu.id}
                    menuElement={submenu}
                    fontColor={fontColor}
                  />
                  </>
                )}
              </ul>
            }
          </li>
        </>
      ) : (
        <></>
      )
    )
  )
};
export default SideMenuItem;